import { ComponentProps, memo, ReactElement, ReactNode } from 'react'
import cn from 'classnames'

interface IProps extends ComponentProps<'div'> {
  children: ReactNode
  actions?: ReactNode
  className?: string
  closeButton?: ReactNode
  headerAdditional?: ReactNode
  icon?: ReactElement
  isMobile?: boolean
  wrapperClassName?: string
}

export const ModalHeader = memo<IProps>(function ModalHeader({
  children,
  className,
  wrapperClassName,
  icon,
  actions,
  closeButton,
  isMobile,
  headerAdditional,
  ...rest
}) {
  if (isMobile) {
    return (
      <div {...rest} className={wrapperClassName}>
        <div className="flex gap-x-4 p-2 text-title-lg">
          {closeButton}
          <div className={cn('w-full py-1', className)}>{children}</div>
          {actions && <div className="h-fit">{actions}</div>}
        </div>
        {headerAdditional}
      </div>
    )
  }

  return (
    <div {...rest} className={wrapperClassName}>
      <div className={cn('flex w-full gap-x-2 px-6 py-5 text-headline-md', icon && '!pl-20')}>
        {icon && <div className="absolute left-6 top-[11px] flex h-12 w-12 items-center">{icon}</div>}
        <div className={cn('w-full', className)}>{children}</div>
        <div className="flex gap-4">
          {actions}
          {closeButton}
        </div>
      </div>
      {headerAdditional}
    </div>
  )
})
